export default __webpack_public_path__ + "static/zhi-3-d457be3b912ca3d9db269d3bbee69d65.jpg";